import { createReducer } from '@reduxjs/toolkit'
import {
  clearGraph,
  removeGraphEdge,
  removeGraphEdges,
  removeGraphNode,
  removeGraphNodes,
  setDevtoolsEnabled,
  setGraphAddingEdge,
  setGraphColorPickerProps,
  setGraphCreatingEdge,
  setGraphRenameRelationProps,
  setGraphEditingLabels,
  setGraphNodeView,
  setGraphNodes,
  setGraphShowingNode,
  updateGraphNodes,
  setSelectedGraphItems,
  setIsEmbeddedView
} from 'Actions/graph'

const initialState = {
  isAddingEdge: false,
  creatingEdgeProps: undefined,
  renameRelationProps: undefined,
  isShowingNode: undefined,
  colorPickerProps: undefined,
  editingLabelProps: undefined,
  devtoolsEnabled: true,
  selectedGraphItems: undefined,
  isEmbeddedView: false,
  nodeView: undefined,
  graphData: {
    abstract: false,
    nodes: {},
    relNodes: {},
    edges: {},
    groups: {}
  }
}

export default createReducer(initialState, {
  [clearGraph]: (state, action) => {
    state.graphData = initialState.graphData
  },
  [removeGraphEdge]: (state, action) => {
    delete state.graphData.edges[action.payload]
  },
  [removeGraphEdges]: (state, action) => {
    action.payload.map((key) => { delete state.graphData.edges[key] })
  },
  [removeGraphNode]: (state, action) => {
    delete state.graphData.nodes[action.payload]
  },
  [removeGraphNodes]: (state, action) => {
    action.payload.map((id) => { delete state.graphData.nodes[id] })
  },
  [setDevtoolsEnabled]: (state, action) => {
    state.devtoolsEnabled = action.payload
  },
  [setGraphAddingEdge]: (state, action) => {
    state.isAddingEdge = action.payload
  },
  [setGraphColorPickerProps]: (state, action) => {
    state.colorPickerProps = action.payload
  },
  [setGraphCreatingEdge]: (state, action) => {
    state.creatingEdgeProps = action.payload
  },
  [setGraphRenameRelationProps]: (state, action) => {
    state.renameRelationProps = action.payload
  },
  [setGraphEditingLabels]: (state, action) => {
    state.editingLabelProps = action.payload
  },
  [setGraphNodeView]: (state, action) => {
    state.nodeView = action.payload
  },
  [setGraphNodes]: (state, action) => {
    state.graphData = action.payload
  },
  [setGraphShowingNode]: (state, action) => {
    state.isShowingNode = action.payload
  },
  [setSelectedGraphItems]: (state, action) => {
    state.selectedGraphItems = action.payload
  },
  [updateGraphNodes]: (state, action) => {

    state.graphData.nodes = {
      ...state.graphData.nodes,
      ...action.payload.nodes
    }

    state.graphData.edges = {
      ...state.graphData.edges,
      ...action.payload.edges
    }

    state.graphData.groups = {
      ...state.graphData.groups,
      ...action.payload.groups
    }

    state.graphData.relNodes = {
      ...state.graphData.relNodes,
      ...action.payload.relNodes
    }

  },
  [setIsEmbeddedView]: (state, action) => {
    state.isEmbeddedView = action.payload
  }
})
